import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../../common.service';
declare var $: any;
@Component({
  selector: 'app-edit-animal-deworming',
  templateUrl: './edit-animal-deworming.component.html',
  styleUrls: ['./edit-animal-deworming.component.css']
})
export class EditAnimalDewormingComponent implements OnInit {
  getdewormingeditApi:any;
  putdewormingeditApi:any;
  EditDewormingFormValue:any;
  addUrl:any;
  getlistApi:any;
  loginresponse:any;
  cby_mby:any;
  getDewormingListData:any;
  returnUrl="/dashboard/RottweilerDogsAnimalmanagement"
  constructor(private router: Router,private commonService:CommonService) { }

  async ngOnInit(){
    this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
    this.cby_mby=this.loginresponse.user_id;
    $('.selectpicker').selectpicker('refresh'); 
    let DewormingId = sessionStorage.getItem('dewormingId');
    this.getdewormingeditApi= "/animal_management/deworming/"+ DewormingId;
    this.putdewormingeditApi= "/animal_management/deworming/"+ DewormingId;
    (await this.commonService.getApi(this.getdewormingeditApi)). subscribe(
      async  (res:any) => {
        this.getlistApi= "/parasite";
        (await this.commonService.getApi(this.getlistApi)).subscribe(
          async (res) => {
            this.getDewormingListData = res.data;
          })
         var date=res.data.tnam_dew_deworming_date;
         var testdate = date.split('T');
        $("#DewormingDate").val(testdate[0])     
        var date=res.data.tnam_dew_expiry_date;
        var testdate = date.split('T');
       $("#ExpiryDate").val(testdate[0])       
        $("#dewormingname").val(res.data.tnam_dew_deworming_name)
        $("#batchNumber").val(res.data.tnam_dew_batch_number)  
         $("#Description").val(res.data.tnam_dew_deworming_description)

        })
  }
  async AnimalDeworming(){
    var farmid=sessionStorage.getItem('farmid');
    var Animalid=sessionStorage.getItem('animalid');
    var speciesid=sessionStorage.getItem('speciesid');
    var breedid=sessionStorage.getItem('breedid');
    var ageid=sessionStorage.getItem('ageid');
    this.EditDewormingFormValue = {
      "species_id":speciesid,
      "breed_id":breedid,
      "farm_id":farmid,
      "animal_code":Animalid,
      "age_group":ageid,
      "deworming_date":$("#DewormingDate").val(),
      "deworming_description":$("#Description").val(),
      "deworming_name":$("#dewormingname").val(),
      "expiry_date":$("#ExpiryDate").val(),
      "batch_number":$("#batchNumber").val(),
      "cby":this.cby_mby,
      "mby":this.cby_mby,
      "status": 1,
      "is_active": 1
     };
    
       (await this.commonService.putApi(this.putdewormingeditApi,this.EditDewormingFormValue)).subscribe(
         data => {
             alert("Data edited successfully");
         });
         setTimeout(
          () : void => {
    
            this.router.navigate([this.returnUrl]);
    
          },
          500
        );
  }
  backnavigate(){
    this.router.navigate([this.returnUrl]);
  }
}
